import {hoistCmp} from '@xh/hoist/core';
import {AddAllocationDialogModel} from './AddAllocationDialogModel';
import {dialog} from '@xh/hoist/kit/blueprint';
import {Icon} from '@xh/hoist/icon';
import {panel} from '@xh/hoist/desktop/cmp/panel';
import {form} from '@xh/hoist/cmp/form';
import {box, filler, hbox, hspacer, vframe} from '@xh/hoist/cmp/layout';
import {formField} from '@xh/hoist/desktop/cmp/form';
import {numberInput, select} from '@xh/hoist/desktop/cmp/input';
import {toolbar} from '@xh/hoist/desktop/cmp/toolbar';
import {button} from '@xh/hoist/desktop/cmp/button';
import classNames from 'classnames';
import {defaultRsOptions} from '../../../cmp/SelectOptions';
import {percentageIcon} from '../../../../core/Icons';

export const addAllocationDialog = hoistCmp.factory<AddAllocationDialogModel>(({model}) =>
    dialog({
        style: {
            width: 250,
            height: 'fit-content'
        },
        icon: percentageIcon(),
        title: 'Add Allocation',
        canOutsideClickClose: false,
        isOpen: model.isOpen,
        onClose: () => model.close(),
        item: panel({
            item: allocationForm(),
            bbar: bbar(),
            mask: model.apiTask
        })
    })
);

const allocationForm = hoistCmp.factory<AddAllocationDialogModel>(({model}) => {
    return form({
        model: model.formModel,
        fieldDefaults: {commitOnChange: true, minimal: true},
        item: vframe(
            formField({
                field: 'securityId',
                label: 'Security',
                item: select({options: model.securityOptions, rsOptions: defaultRsOptions()})
            }),
            formField({
                field: 'portfolioId',
                label: 'Portfolio',
                item: pSelect(model)
            }),
            formField({
                field: 'allocationPct',
                label: 'Allocation %',
                item: numberInput({scaleFactor: 100})
            })
        )
    });
});

const pSelect = (model: AddAllocationDialogModel) => {
    return select({
        className: 'allocation-portfolio-select',
        options: model.portfolioOptions,
        optionRenderer: option => {
            const isSelected = model.formModel.values.portfolioId === option.value;
            return box({
                className: classNames('allocation-portfolio-select__option', isSelected ? 'allocation-portfolio-select__option_selected' : null),
                items: [
                    box({
                        minWidth: 20,
                        alignItems: 'center',
                        justifyContent: 'center',
                        item: isSelected ? Icon.check({size: 'sm'}) : null
                    }),
                    Icon.portfolio(),
                    hspacer(5),
                    option.label
                ]
            });
        },
        rsOptions: defaultRsOptions({
            formatGroupLabel: group =>
                hbox({
                    className: 'allocation-portfolio-select__group-label',
                    items: [Icon.user(), hspacer(5), group.label]
                })
        })
    });
};

const bbar = hoistCmp.factory<AddAllocationDialogModel>(({model}) =>
    toolbar(
        filler(),
        button({
            text: 'Cancel',
            icon: Icon.cross(),
            onClick: () => model.close()
        }),
        button({
            text: 'Add',
            icon: Icon.check(),
            intent: 'primary',
            disabled: !model.formModel.isValid,
            onClick: () => model.save()
        })
    )
);
